import { useState, type ReactNode } from 'react';

interface PublicAssetImgProps {
  readonly src: string;
  readonly alt: string;
  readonly className?: string;
  readonly fallback?: ReactNode;
  readonly width?: number;
  readonly height?: number;
  readonly loading?: 'eager' | 'lazy';
}

// Render an <img> pointing at a static asset under /public. If the file
// doesn't exist (404), hide the img and render the fallback instead. Used
// for hero / logo when an admin hasn't uploaded a Cloudinary version yet
// but the developer may have dropped a file in client/public/.
export function PublicAssetImg(props: PublicAssetImgProps): JSX.Element {
  const [failed, setFailed] = useState(false);

  if (failed) return <>{props.fallback ?? null}</>;

  return (
    <img
      src={props.src}
      alt={props.alt}
      className={props.className}
      width={props.width}
      height={props.height}
      loading={props.loading ?? 'lazy'}
      decoding="async"
      onError={() => setFailed(true)}
    />
  );
}
